<template>
  <div class="design-options step" :class="{active: active, selected: selected, unlocked: unlocked}">
    <modal name="digital-proof-modal" :adaptive="true" class="message-modal" height="auto">
      <message-modal
        type="warning"
        title="Warning"
        contents="All sales of Fathead Custom Creations are final once your item prints. You may elect to receive a free digital proof. Proofs are sent by email, so you can see exactly what your custom order will look like before we print. Please allow an additional 2-3 business days for order processing when you select a proof."
        buttonText="I Understand"
        modalName="digital-proof-modal"
      ></message-modal>
    </modal>
    <div class="step-header" @click="setActive">
      <span class="title">{{optionGroup.name}}</span>
      <icon-check />
    </div><!-- /.step-header -->
    <div class="step-body" v-if="active">
      <div class="description-wrapper" v-if="optionGroup.description">
        <p class="description secondary-font small">{{optionGroup.description}}</p>
      </div><!-- /.description-wrapper -->

      <div class="flex-container is-vertical">
        <design-option-selection
          v-for="option in optionGroup.options"
          :option="option"
          :key="`${option.optionCode}-design-option`"
        ></design-option-selection>
      </div><!-- /.flex-container -->
    </div><!-- /.step-body -->
  </div><!-- /.design-options -->
</template>

<script>
import { validateDesignOptions } from "@/helpers/validation"
import DesignOptionSelection from "@/components/steps/DesignOptionSelection"
import MessageModal from "@/components/global/MessageModal"
import { mapActions } from "vuex"

export default {
  name: "DesignOptions",
  components: {
    DesignOptionSelection,
    MessageModal
  },
  data: function() {
    return {
      title: "Choose Design Options",
    }
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    },
    optionGroup: {
      type: Object,
      required: true,
      validator: function(value) {
        return validateDesignOptions(value);
      }
    }
  },
  methods: {
    ...mapActions(["setActiveGroup", "setDeactiveGroup"]),
    setActive() {
      if (this.unlocked) {
        if (this.active) {
          this.setDeactiveGroup()
        }
        else {
          this.setActiveGroup(this.optionGroup)
        }
      }
    }
  }
}
</script>
